import React from 'react';

/**
 * Subtle decorative botanical line-art (original artwork).
 * Renders faint outlined poppy-style flowers, like editorial decoration.
 */
export default function BotanicalDecor({ style = {}, className = '', flip = false, color = '#CFE0BC' }) {
  return (
    <div className={`botanical ${className}`} style={style} aria-hidden="true">
      <svg viewBox="0 0 240 520" fill="none" xmlns="http://www.w3.org/2000/svg"
        style={{ transform: flip ? 'scaleX(-1)' : 'none' }}>
        <g stroke={color} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
          {/* long stems */}
          <path d="M150 500 C 140 400 130 300 118 210" />
          <path d="M150 500 C 165 380 175 300 168 250" />
          {/* leaves */}
          <path d="M138 360 C 110 350 92 366 96 392 C 122 392 140 378 138 360 Z" />
          <path d="M162 320 C 190 308 208 322 206 348 C 180 350 160 340 162 320 Z" />
          <path d="M132 300 C 106 296 90 312 96 334 C 120 332 136 318 132 300 Z" />
          {/* flower 1 (poppy) */}
          <g>
            <path d="M118 210 C 92 196 78 168 92 146 C 106 128 132 130 142 150 C 156 132 184 138 188 164 C 192 190 170 208 148 206" />
            <path d="M118 210 C 130 214 146 214 158 206" />
            <circle cx="132" cy="176" r="12" />
            <path d="M132 164 L132 156 M132 196 L132 188 M120 176 L112 176 M152 176 L144 176 M124 168 L118 162 M140 168 L146 162 M124 184 L118 190 M140 184 L146 190" />
          </g>
          {/* flower 2 bud */}
          <g>
            <path d="M168 250 C 152 244 146 226 158 214 C 168 204 186 210 188 226 C 200 218 214 228 210 244 C 206 258 188 262 176 254" />
            <circle cx="180" cy="234" r="7" />
          </g>
        </g>
      </svg>
    </div>
  );
}
